import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { topRatedMovies } from "@/lib/content";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex w-full flex-1 items-center justify-center px-4 pb-20 pt-32">
        <div className="w-full max-w-2xl">
          <div className="rounded-lg border border-background-200 bg-background-100 px-6 py-14 text-center">
            <p className="font-label text-6xl font-black text-primary-200 select-none">404</p>
            <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              这个页面走丢了
            </h1>
            <p className="mt-2 text-sm leading-6 text-foreground-500">
              你访问的地址 <span className="font-label text-foreground-700">{location.pathname}</span> 不存在，
              可能是链接输入有误。可以从下面的入口继续浏览。
            </p>
            <div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-900 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors whitespace-nowrap hover:bg-primary-800"
              >
                <i className="ri-home-5-line text-base" aria-hidden="true" />
                返回首页
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center justify-center gap-1.5 rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors whitespace-nowrap hover:border-primary-300 hover:text-primary-700"
              >
                浏览影视剧分类
              </Link>
            </div>
          </div>

          <div className="mt-8">
            <h2 className="font-heading text-sm font-bold text-foreground-950">不妨看看这些高分作品</h2>
            <div className="mt-3 flex flex-col gap-2">
              {topRatedMovies.map((movie) => (
                <Link
                  key={movie.id}
                  to={`/detail/${movie.id}`}
                  className="group flex items-center gap-3 rounded-md border border-background-200 bg-background-50 px-4 py-3 transition-colors hover:border-primary-300"
                >
                  <span className="font-label text-xs font-bold text-accent-700">{movie.rating.toFixed(1)}</span>
                  <span className="font-heading text-sm font-semibold text-foreground-800 transition-colors group-hover:text-primary-700">
                    {movie.title}
                  </span>
                  <span className="text-xs text-foreground-400">{movie.year} · {movie.genres.join(" / ")}</span>
                  <i className="ri-arrow-right-line ml-auto text-base text-foreground-300 group-hover:text-accent-500" aria-hidden="true" />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}